var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 16,
    fill: "#1E334E",
    stroke: "white",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 22.1171C15.6084 22.5076 15.6084 23.1408 15.9989 23.5313C16.3895 23.9218 17.0226 23.9218 17.4132 23.5313L15.9989 22.1171ZM20.5296 19.0007L21.2367 19.7078C21.4242 19.5203 21.5296 19.2659 21.5296 19.0007C21.5296 18.7355 21.4242 18.4811 21.2367 18.2936L20.5296 19.0007ZM17.4132 14.4701C17.0226 14.0795 16.3895 14.0795 15.9989 14.4701C15.6084 14.8606 15.6084 15.4937 15.9989 15.8843L17.4132 14.4701ZM17.4132 23.5313L21.2367 19.7078L19.8225 18.2936L15.9989 22.1171L17.4132 23.5313ZM21.2367 18.2936L17.4132 14.4701L15.9989 15.8843L19.8225 19.7078L21.2367 18.2936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowStroke);
export default __webpack_public_path__ + "static/media/right-arrow-stroke.8c7143f0aef9d8ca47a82f07f4b55b1c.svg";
export { ForwardRef as ReactComponent };